<template>
  <v-container id="page-driver-list">
    <div class="page-title">{{ $route.name }}</div>

    <v-row>
      <v-col>
        <v-menu
          v-model="registerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px; display: inline-block">
              <v-text-field
                clearable
                v-model="registerDate"
                label="기사등록일"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker
            v-model="registerDate"
            @input="registerMenu = false"
            firstDayOfWeek="1"
            :selectedDate="registerDate"
            locale="ko-kr"
          ></c-date-picker>
        </v-menu>
        <div style="width: 250px; display: inline-block; margin-left: 18px;">
          <v-text-field
            v-model="searchKeyword"
            label="기사명 검색"
            prepend-icon="search"
            maxlength="32"
            @keyup="onSearch"
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn
          color="blue"
          outlined
          iconName="add"
          @click="addDriverDialog = true"
          :disabled="disabledByRole"
          >기사등록</c-btn
        >
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="delete"
          @click="onDeleteDrivers"
          :disabled="disabledByRole"
          >기사삭제</c-btn
        >
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="attach_file"
          @click="addDriverBulkRegistDialog = true"
          :disabled="disabledByRole"
          >일괄등록</c-btn
        >
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="attach_file"
          @click="downloadSample"
          :disabled="disabledByRole"
          >등록 양식</c-btn
        >
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="file_download"
          @click="downloadDriverExcel"
          :disabled="disabledByRole"
          >Excel</c-btn
        >
        <vue-excel-xlsx
          id="excelDownloadButton"
          :data="excelDriverList"
          :columns="excelColumns"
          :filename="getExcelFilename"
          sheetname="기사목록"
        />
      </v-col>
    </v-row>
    <c-table
      :headers="driverTableHeaders"
      itemKey="id"
      :items="driverList"
      :selected.sync="selected"
      show-select
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #detail="{ item }">
        <c-btn icon iconName="search" @click="onMoveDetail(item)" />
      </template>
      <template #created="{item}">
        {{ $func.dateToString(item.created) }}
      </template>
    </c-table>

    <driver-c-u-dialog
      :open.sync="addDriverDialog"
      @reqAddDriver="reqAddDriver"
    />
    <bulk-data-register-dialog
      :open.sync="addDriverBulkRegistDialog"
      uploadTarget="기사"
      @fileData="reqBulkRegist"
    />
    <bulk-data-result-dialog
      :open.sync="bulkRegisterResultDialog"
      :resultBulkData="resultBulkData"
      :resultBulkUploadType="resultBulkUploadType"
      @downloadFailedData="downloadFailedData"
    />

    <download-excel-dialog
      :open.sync="downloadExcelDialog"
      @reqDownloadExcel="reqDownloadExcel"
    />
  </v-container>
</template>
<script>
import DriverCUDialog from "./DriverCUDialog";
import BulkDataRegisterDialog from "../Common/BulkDataRegisterDialog";
import BulkDataResultDialog from "../Common/BulkDataResultDialog";
import DownloadExcelDialog from "../Common/DownloadExcelDialog";
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    DriverCUDialog,
    BulkDataResultDialog,
    BulkDataRegisterDialog,
    DownloadExcelDialog,
  },
  data: () => ({
    driverTableHeaders: [
      {
        text: "이름",
        value: "name",
        align: "center",
        sortable: true,
      },
      {
        text: "연락처",
        value: "mobileNo",
        align: "center",
        sortable: true,
      },
      {
        text: "배정차량 대수",
        value: "vehicleCnt",
        align: "center",
        sortable: true,
      },
      {
        text: "등록일",
        value: "created",
        align: "center",
        sortable: true,
      },
      {
        text: "상세보기",
        value: "detail",
        align: "center",
        sortable: false,
      },
    ],
    excelColumns: [
      { label: "이름", field: "name" },
      { label: "연락처", field: "mobileNo" },
      { label: "배정차량 대수", field: "vehicleCnt" },
      { label: "등록일", field: "created" },
    ],
    driverList: [],
    excelDriverList: [],
    addDriverDialog: false,
    addDriverBulkRegistDialog: false,

    addDriverFormData: {
      name: "",
      gender: "",
      mobile_no: "",
      license_no: "",
      address: "",
      birth: "",
      photo: "",
    },
    selected: [],
    registerMenu: false,
    registerDate: "",
    searchKeyword: "",
    downloadExcelDialog: false,

    resultBulkData: null,
    resultBulkUploadType: "new",
    bulkRegisterResultDialog: false,
    searchType: "DRIVER_NAME",
    pagination: {
      page: 1,
      size: 10,
      sort: "",
    },
    totalElements: 0,
  }),
  activated() {
    this.reqGetDriverList();
  },
  watch: {
    registerDate: function() {
      this.reqGetDriverList();
    },
  },
  computed: {
    getExcelFilename() {
      return "기사목록_" + this.$func.dateToString(new Date());
    },
    disabledByRole() {
      return this.$store.state.userInfo.role === "RM";
    },
  },
  methods: {
    onMoveDetail(item) {
      this.$router.push(`/drivers/${item.id}`);
    },

    async reqAddDriver(data) {
      try {
        const res = await this.$api.addDriver(data);
        this.addDriverDialog = false;
        this.reqGetDriverList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqAddDriver" });
      }
    },
    async reqGetDriverList() {
      try {
        const params = {
          ...this.pagination,
          searchType: this.searchType,
          searchKeyword: this.searchKeyword,
          created: this.registerDate ? this.registerDate : "",
        };
        const res = await this.$api.getDriverList(params);
        this.driverList = res.data.content;
        this.totalElements = res.data.totalElements;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetDriverList" });
      }
    },
    async downloadDriverExcel() {
      const { data } = await this.$api.getDriverListForExcel()
      this.excelDriverList = data;
      this.downloadExcelDialog = true;
    },
    async reqBulkRegist(data) {
      try {
        const res = await this.$api.driverBulkRegist(data);

        this.resultBulkData = res.data;
        this.resultBulkUploadType = data.get("uploadType");
        this.bulkRegisterResultDialog = true;
        this.reqGetDriverList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqBulkRegist" });
      }
      this.addDriverBulkRegistDialog = false;
    },
    async downloadFailedData(fileName) {
      try {
        const response = await this.$api.downloadFiles(fileName);

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.headers["content-type"] })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "downloadFailedData" });
      }
    },
    async downloadSample() {
      window.location.href = this.$func.getExcelUrl(
        "/기사_일괄_등록_양식.xlsx"
      );
    },
    async onDeleteDrivers() {
      if (this.selected.length < 1) {
        this.$store.commit("alert", {
          open: true,
          msg: "삭제할 기사를 선택해주세요.",
        });
      } else {
        // 주행 중인 예약 유무 확인
        if (await this.reqDrivingReservCheck()) {
          this.$store.commit("snackbar", {
            msg: "주행 중인 기사는 삭제가 불가능합니다.",
          });
          return;
        }

        this.$store.commit("alert", {
          open: true,
          msg:
            "차량이 배정된 기사는 예약건의 배차가 취소 됩니다.\n삭제를 원하는 경우 확인 버튼을 눌러주세요.",
          confirm: true,
          persistent: true,
          callBack: () => {
            this.reqDeleteDrivers();
          },
        });
      }
    },
    async reqDeleteDrivers() {
      try {
        let total = this.selected.length;
        let isDeleted = this.selected;
        const res = await this.$api.deleteDrivers(isDeleted);
        let msg = "";
        if (total === res.data.length) {
          msg = "선택한 모든 기사가 삭제되었습니다.";
        } else {
          msg =
            "선택한 " +
            total +
            " 명의 기사중 " +
            res.data.length +
            " 명이 삭제되었습니다.";
        }
        this.reqGetDriverList();
        this.$store.commit("snackbar", { timeout: 4000, msg });
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqDeleteDrivers" });
      }
    },
    async reqDownloadExcel() {
      document.getElementById("excelDownloadButton").click();
      this.downloadExcelDialog = false;
    },
    async reqDrivingReservCheck() {
      try {
        const driverIds = this.selected.map((item) => item.id);
        const res = await this.$api.checkDrivingReservation(driverIds);
        return res.data;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqDrivingReservCnt" });
      }
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqGetDriverList();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqGetDriverList();
      } else {
        return;
      }
    },
  },
};
</script>

<style>
.birth-select {
  width: 50px !important;
  margin: 0 10px !important;
}
</style>
